
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gVeWAjlYnl72eZo0oI2K15rCNnKgp1SmSiq11U4ATLMgMeta } from "/codebuild/output/src415084185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexHte6UED8d3R6VkpiWFy8k_45GZVxIIdPfa9ETIX8EgT9QMeta } from "/codebuild/output/src415084185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as search3wE7TX2eBdUZpAjfRBRgf9N_45F45jR3_qHiZRgRC1RAIMeta } from "/codebuild/output/src415084185/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexLXW3zP0Kf37DwMltekpCUkKLJlt_45zUlpaUtYr7rGT94Meta } from "/codebuild/output/src415084185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93qxZT_NUHaNr1eKZT_45jIDy_OjgjdMrl5xgLoPW0utE0wMeta } from "/codebuild/output/src415084185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexFj21lPn1j2hCzzeLeJr79Jl4yU7u_vaghAFO_3Wh9iIMeta } from "/codebuild/output/src415084185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93PnMAkol6ecYULvGDiazG8PxrLyNlk2ooQV5PzAT9ppsMeta } from "/codebuild/output/src415084185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index5jUx_45RJOwh8jPxx0V6HTqjWwxr2RaxOukVC9QtX_4581kMeta } from "/codebuild/output/src415084185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_931FhAhpHrVhJzuodGA_45_45NYHLI_5tUX1lvKQo4z3P4UAgMeta } from "/codebuild/output/src415084185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexp_451o6IrFY_45T3gbjFs4H2P2YrzdTzrKiM7fH0p1EWjY8Meta } from "/codebuild/output/src415084185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indext_ucCDJP2YvdlNMR7c0didMUb_6ZKA2zjRctQ8sTx0AMeta } from "/codebuild/output/src415084185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src415084185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src415084185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src415084185/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src415084185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src415084185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexFj21lPn1j2hCzzeLeJr79Jl4yU7u_vaghAFO_3Wh9iIMeta || {},
    component: () => import("/codebuild/output/src415084185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src415084185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index5jUx_45RJOwh8jPxx0V6HTqjWwxr2RaxOukVC9QtX_4581kMeta || {},
    component: () => import("/codebuild/output/src415084185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src415084185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexp_451o6IrFY_45T3gbjFs4H2P2YrzdTzrKiM7fH0p1EWjY8Meta || {},
    component: () => import("/codebuild/output/src415084185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indext_ucCDJP2YvdlNMR7c0didMUb_6ZKA2zjRctQ8sTx0AMeta || {},
    component: () => import("/codebuild/output/src415084185/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]